export const GET_LOGIN_LOADING_DISP = 'GET_LOGIN_LOADING_DISP'
export const SET_LOGIN_LOADING_DISP = 'SET_LOGIN_LOADING_DISP'

export const SET_LOGIN_LOGIN_DISP = 'SET_LOGIN_LOGIN_DISP'
export const GET_LOGIN_LOGIN_DISP = 'GET_LOGIN_LOGIN_DISP'

export const SET_LOGIN_FORGOT_PASSWORD_DISP = 'SET_LOGIN_FORGOT_PASSWORD_DISP'
export const GET_LOGIN_FORGOT_PASSWORD_DISP = 'GET_LOGIN_FORGOT_PASSWORD_DISP'

export const SET_LOGIN_FORGOT_PASSWORD_VERIFY_DISP = 'SET_LOGIN_FORGOT_PASSWORD_VERIFY_DISP'
export const GET_LOGIN_FORGOT_PASSWORD_VERIFY_DISP = 'GET_LOGIN_FORGOT_PASSWORD_VERIFY_DISP'

export const SET_LOGIN_CHANGE_PASSWORD_DISP = 'SET_LOGIN_CHANGE_PASSWORD_DISP'
export const GET_LOGIN_CHANGE_PASSWORD_DISP = 'GET_LOGIN_CHANGE_PASSWORD_DISP'

export const GET_LOGIN_LABELS = 'GET_LOGIN_LABELS'

export const SET_BASE_CONNECTION = 'SET_BASE_CONNECTION'
export const GET_BASE_CONNECTION = 'GET_BASE_CONNECTION'
export const RECEIVED_BASE_CONNECTION = 'RECEIVED_BASE_CONNECTION'

export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const GET_CURRENT_USER = 'GET_CURRENT_USER'
export const SET_AUTH_STATUS = 'SET_AUTH_STATUS'
export const GET_AUTH_STATUS = 'GET_AUTH_STATUS'
export const POST_CURRENT_USER = 'POST_CURRENT_USER'
export const POST_FORGOT_PASSWORD = 'POST_FORGOT_PASSWORD'
export const POST_FORGOT_PASSWORD_VERIFY = 'POST_FORGOT_PASSWORD_VERIFY'
export const SET_FORGOT_DATA = 'SET_FORGOT_DATA'
export const POST_CHANGE_PASSWORD = 'POST_CHANGE_PASSWORD'
export const SET_LOGIN_FORMAT_PASSWORD = 'SET_LOGIN_FORMAT_PASSWORD'
export const GET_LOGIN_FORMAT_PASSWORD = 'GET_LOGIN_FORMAT_PASSWORD'
export const SET_RESPONSE = 'SET_RESPONSE'
export const GET_RESPONSE = 'GET_RESPONSE'
export const SET_LOGIN_FLG_ACTION = 'SET_LOGIN_FLG_ACTION'
export const GET_LOGIN_FLG_ACTION = 'GET_LOGIN_FLG_ACTION'
export const SET_FORGOT_PASSWORD_RESPONSE = 'SET_FORGOT_PASSWORD_RESPONSE'
export const GET_FORGOT_PASSWORD_RESPONSE = 'GET_FORGOT_PASSWORD_RESPONSE'
export const SET_CHANGE_PASSWORD_RESPONSE = 'SET_CHANGE_PASSWORD_RESPONSE'
export const GET_CHANGE_PASSWORD_RESPONSE = 'GET_CHANGE_PASSWORD_RESPONSE'
export const SET_LANG = 'SET_LANG'
export const GET_LANG = 'GET_LANG'
export const SET_LOGOUT = 'SET_LOGOUT'
export const GET_LOGOUT = 'GET_LOGOUT'
export const POST_LOGOUT = 'POST_LOGOUT'
export const SET_AUTH_VUE_RESPONSE = 'SET_AUTH_VUE_RESPONSE'
export const GET_AUTH_VUE_RESPONSE = 'GET_AUTH_VUE_RESPONSE'
export const POST_AUTH_VUE_MIDDLEWARE = 'POST_AUTH_VUE_MIDDLEWARE'
export const TOGGLE_LOGIN_PAGE = 'TOGGLE_LOGIN_PAGE'



// WEBPACK FOOTER //
// ./src/store/modules/login/mutation-types.js